module.exports = __webpack_public_path__ + "img/login-logo.11a7e53c.png";